import React from 'react';
import Container from './Container';


const Content = () => {
	return <div className="Content Section" id="whatis">
		<Container>
			<h2>Что такое Alternative Tycoon</h2>
			<p>Симулятор IT-компании, выпускающей моды для игры майнкрафт. Игра направлена на развитие у игрока финансовой грамотности</p>
			<p>Наша команда предлагает приложение, которое в простой форме познакомит пользователей с основами финансовой грамотности. В процессы игры пользователю предстоит столкнуться с проблемами реальных IT-компаний и постараться решить их</p>
			<div className="pc"></div>

			<p>Игра доступна на PC, операционной системы Windows </p>
		</Container>
	</div>
}

export default Content